if (!customElements.get('sticky-atc')) {

class StickyATC extends HTMLElement {

  constructor() {

    super({
      name: 'Sticky ATC',
      version: '2.0.0'
    })
  }

  connectedCallback() {

    this.stickyATCUpper = document.querySelector('.section-main-product')

    if (!this.stickyATCUpper) return;

    this.button = this.querySelector('[data-sticky-atc-btn]')
    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')

    document.documentElement.style.setProperty('--footer-offset', `${this.offsetHeight}px`);

    new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2  }).observe(this.stickyATCUpper)

    this.colorSelectorDrawerListener()
    this.variantSelectorListener()

    this.button.addEventListener('click', this.onClickHandler.bind(this));

    this.mobileButton = this.querySelector('.mobile-trigger button');
    this.mobileButton?.addEventListener('click', this.onClickHandlerMobile.bind(this));

  }

  disconnectedCallback() {

    if (!this.stickyATCUpper) return;

    // disconnect IntersectionObserver
    const observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2  })
    observer.unobserve(this.stickyATCUpper)
  }

  handleUpperIntersect(entries, observer) {

    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')

    entries.forEach((entry) => {

      if (entry.isIntersecting) {
        // hide when scrolling up
        document.body.classList.remove('sticky-atc-active');
        document.querySelector('sticky-atc').style.transform = "translateY(calc(100% + var(--layout-space-24)))"
        this.variantSelector?.classList.remove('active')
        this.colorSelector?.classList.remove('active')
      }else{
        // show when scrolling down
        document.body.classList.add('sticky-atc-active');
        document.querySelector('sticky-atc').style.transform = "translateY(0)"
        this.variantSelector?.classList.remove('active')
        this.colorSelector?.classList.remove('active')
      }
    })
  }


  colorSelectorDrawerListener() {
    this.colorSelector?.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
      this.colorSelector.classList.toggle('active')
      this.variantSelector?.classList.remove('active')
    })
  }

  variantSelectorListener() {
    this.variantSelector?.querySelector('.product__variant-selector--wrapper').addEventListener('click', () => {
      this.variantSelector.classList.toggle('active')
      this.colorSelector?.classList.remove('active')
    })
  }


  onClickHandler(event) {
    event.preventDefault();
    var clickedButtonEl = event.target;
    var mainAtc = document.querySelector('product-form .product-form__submit:not(.klaviyo-bis-trigger)');

    const isKlaviyoBisButton = clickedButtonEl.classList.contains('klaviyo-bis-trigger');
    if (isKlaviyoBisButton) {
      mainAtc = document.querySelector('product-form .product-form__submit.klaviyo-bis-trigger');
    } else {
      const spinnerEl = clickedButtonEl.querySelector('.loading-overlay__spinner');
      clickedButtonEl.classList.add('loading');
      spinnerEl.classList.remove('hidden');

      setTimeout(() => {
        clickedButtonEl.classList.remove('loading');
        spinnerEl.classList.add('hidden');
      }, 1000);
    }

    if(mainAtc){
      mainAtc.click();
    }
  }

  onClickHandlerMobile(event) {
    event.preventDefault();
    // Scroll to top on mobile devices
    if (window.innerWidth < 750) {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }

}

customElements.define('sticky-atc', StickyATC);

}
